/** Map a 0–100 confidence to its warm→cool risk token, as a usable CSS colour. */
export function riskColor(v: number): string {
  const token =
    v < 40 ? '--ignition' : v < 55 ? '--flare' : v < 70 ? '--ember' : v < 80 ? '--trace' : '--stable'
  return `rgb(var(${token}))`
}

/** A token name -> CSS colour, e.g. tok('--flare'). */
export const tok = (name: string) => `rgb(var(${name}))`

/** Resolve a channel token to a concrete rgb() string (for canvas libs like ECharts). */
export function resolveToken(name: string, fallback = '#FF663C'): string {
  if (typeof window === 'undefined') return fallback
  const channels = getComputedStyle(document.documentElement).getPropertyValue(name).trim()
  return channels ? `rgb(${channels})` : fallback
}
